import { bemClassBuilder } from '@vista-digital/bem-class-builder/src/lib/bem-class-builder'
import type { HeroBannerCarouselItemImageWeb } from '@vista-digital/lumos-cms-client'
import { HeroBanner, Link } from '@vista-digital/occ-ui'
import { convertToKebabCase } from '@vista-digital/utilities/src/lib/strings/convert-to-kebab-case'
import type { FC } from 'react'

const componentName = 'HeroBannerItemImage'
const b = bemClassBuilder(convertToKebabCase(componentName))

export const HeroBannerItemImage: FC<HeroBannerCarouselItemImageWeb> = props => {
    const { image, altText, url } = props

    const Banner = (
        <div className={b.element('container')}>
            <div className={b.element('wrapper')} style={{ backgroundImage: `url(${image})` }}>
                <HeroBanner src={image} alt={altText} />
            </div>
        </div>
    )

    if (url) {
        return (
            <Link className={b.element('link')} href={url}>
                {Banner}
            </Link>
        )
    }
    return Banner
}

HeroBannerItemImage.displayName = componentName
